import { EntityList } from '@/common/entityFramework/entityList/EntityList'
import { ExprUtils } from '@/common/utils/ExprUtils'
import { useCallback } from 'react'

export const ClaimList = ({ pymtObj }) => {

  const augRowsReq = useCallback((rowsReq) => {
    rowsReq.expr = ExprUtils.and(rowsReq.expr, ExprUtils.whereParams('id', pymtObj.claimIds))
  }, [pymtObj.claimIds])

  if (!pymtObj.claimIds) {
    return null;
  }

return (
  <EntityList entity={`${pymtObj.claimType}_CLAIM`} augRowsReq={augRowsReq} />
)
}
